import React from 'react'
import { Modal } from "react-bootstrap"
import { Link } from 'react-router'

import Button from '../components/Button.jsx'
import { getText, nameOrTitle } from '../lib/text'

// TODO mostrar también gastos-referencia

const Item = ({item, daysCounter, Activities}) => (
  <li style={{marginLeft: (item.type === "day" ? 0 : 25)}}>
    {
      (item.type === "day" && `${getText("dia_1")}${daysCounter}${getText("dia_2")}`)
        || (item.type === "activity" && nameOrTitle(Activities[item.id]))
        || (item.type === "expense" && ((item.expense && nameOrTitle(item.expense)) || getText("Gasto repetido")))
        || (item.type === "hotel" && ((item.expense && nameOrTitle(item.expense)) || getText("Hotel repetido")))
        || (item.type === "city" && `${getText("Viaje a")} ${item.city}`)
        ||  ""
    }
  </li>
)

type Props = {
  block: Object,
  route: Object,
  Activities: Object,
  onClose: () => void
}

const BlockPreview = ({ block, route, Activities, onClose }: Props) => {
  let daysCounter = 1

  return (
    <Modal show bsSize="normal" onHide={() => this.props.onClose()}>
      <Modal.Header>
        <Modal.Title>
          {nameOrTitle(block)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{maxHeight: 472, overflowY: "scroll"}}
      >
        <ul>
          {
            route.agenda.map((x, i) => (
              <Item
                key={i} // Allowed: blockPreview is used in BlockSelector, has no updates.
                item={x}
                daysCounter={x.type == "day" ? daysCounter++ : daysCounter}
                Activities={Activities}
              />
            ))
          }
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Link
          to={"/private/block/"+encodeURIComponent(block._id)}
          style={{float:"left"}}
        >
          Visualizar plantilla
        </Link>
        <Button onClick={() => onClose()}>
          {getText("Cerrar")}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default BlockPreview
